import { InputLeftAddon as ChakraInputLeftAddon } from '@chakra-ui/react';

export const InputLeftAddon = ChakraInputLeftAddon;
